module.exports = __webpack_public_path__ + "img/6_100.bd5cc240.png";